
















































































import ContentPayment from '@/app/shared/components/contents/payment.vue';
import DialogGenerateLinkUpdate from '@/app/shared/components/dialogs/generate-link-update.vue';
import DialogPayment from '@/app/shared/components/dialogs/payment.vue';
import { InteractionModel } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: { DialogPayment, DialogGenerateLinkUpdate, ContentPayment },
})
export default class PanelPaymentComponent extends Vue {
  private show = false;
  private dialogPayment = false;
  private dialogGenerateLink = false;
  private showLinkGeneration = false;
  private dialogCarnetAlert = false;
  private get refs() {
    return refsService;
  }

  private setPaymentDestination() {
    if (
      this.refs.modules.contract.contract.BillingMode != null &&
      this.refs.enums.BillingMode[
        this.refs.modules.contract.contract.BillingMode
      ] == this.refs.enums.BillingMode.Carnet.toString()
    ) {
      this.dialogCarnetAlert = true;
    } else {
      this.refs.modules.contract.SET_PAYMENT_DESTINATION(
        this.refs.enums.PaymentDestination.Contract
      );
      this.dialogPayment = true;
    }
  }

  private get contractModule() {
    return this.refs.modules.contract;
  }

  created() {
    const address = this.refs._.clone(
      this.refs._.head(this.contractModule.customer.Addresses)
    );
    if (address) {
      this.contractModule.SET_ADDRESS(address);
    }
  }

  private async openContent() {
    this.show = !this.show;
    if (this.show) {
      this.showLinkGeneration = true;
    } else {
      this.showLinkGeneration = false;
    }
    if (this.show && !this.refs.modules.ticket.consultPaymentMethod) {
      this.refs.modules.ticket.SET_CONSULT_PAYMENT_METHOD(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac0'),
          this.$t('action_desc.ad3')
        )
      );
    }
  }
}
